import React from 'react';
var Copy = function Copy(_ref) {
    var width = _ref.width, height = _ref.height, color = _ref.color;
    return /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        viewBox: "0 0 12 12"
    }, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("rect", {
        width: "8",
        height: "8",
        transform: "translate(0 4)",
        fill: color
    }), /*#__PURE__*/ React.createElement("g", {
        transform: "translate(4)"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M341.054,242.514h-2v-6h-6v-2h8Z",
        transform: "translate(-333.054 -234.514)",
        fill: color
    }))));
};
export default Copy;
